// extracted by mini-css-extract-plugin
module.exports = {"SectorTeam":"styles_SectorTeam__yLH83","bg_1":"styles_bg_1__vfstx","bg_2":"styles_bg_2__I5_gu","carousel":"styles_carousel__z4fUB","height":"styles_height__yx7XZ"};